import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { Box, Typography } from "@mui/material";
import { formatNumber } from "src/utils";
import { useTranslation } from "react-i18next";
import { SalaryCapitalRow } from "src/types/salary";
import { useDeleteSalaryOwnerPayment } from "src/api/salary/salaries";
import DeleteRowAction from "../delete-row-action";

const headCellSx = {
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "18px",
  color: "#475467",
  bgcolor: "#F9FAFB",
  whiteSpace: "nowrap",
} as const;

const SalaryOwnersPaymentsTable = ({
  list,
  isLoading,
  refetch,
}: {
  list: SalaryCapitalRow[];
  isLoading: boolean;
  refetch: () => void;
}) => {
  const { t: purchasingT } = useTranslation("purchasing");
  const { t: generalT } = useTranslation("general");
  const deleteMutation = useDeleteSalaryOwnerPayment();

  const tableHeadText = [
    generalT("ID"),
    purchasingT("owner"),
    generalT("amount"),
    generalT("paymentDate"),
    generalT("actions"),
  ];

  return (
    <Box>
      <Typography mb={1}>{purchasingT("ownersPayments")}</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {tableHeadText.map((item) => (
                <TableCell key={item} align="center" sx={headCellSx}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={4} cellsLength={5} />
          ) : (
            <TableBody>
              {list.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.id}</TableCell>
                  <TableCell align="center">
                    {row.capital?.name ?? "-"}
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: 600 }}>
                    {formatNumber(row.amount)}
                  </TableCell>
                  <TableCell align="center">{row.date ?? "-"}</TableCell>
                  <TableCell align="center">
                    <DeleteRowAction
                      item={row.capital?.name ?? String(row.id)}
                      mutation={deleteMutation}
                      variables={{ capitalId: row.id }}
                      refetch={refetch}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {!isLoading && list.length === 0 && <NoData />}
      </TableContainer>
    </Box>
  );
};

export default SalaryOwnersPaymentsTable;
